<template>
  <div class="content">
    <div class="header">
      <h1>{{ pageTitle }}</h1>
    </div>
    <div class="content-body form-wrapper quote-form-wrapper left">
      <Spin v-if="loading"></Spin>
      <div v-else>
        <div v-if="!isEmpty">
          <ul v-for="(items, status) in grouped" :key="`status--${status}`">
            <h3>{{ getStatusLabel(status) }}</h3>
            <li v-for="todo in items" :key="todo.id">
              <Todo :badge-text="todo.model_type" :get-label-func="getStatusLabel" :todo.sync="todos[todo.id]"></Todo>
            </li>
          </ul>
        </div>
        <div v-else>{{ $t('task.no_tasks') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Todo from './todo'
export default {
  name: 'Todos',
  components: {
    Todo
  },
  data () {
    return {
      loading: false,
      todos: null
    }
  },
  computed: {
    grouped () {
      return _.groupBy(this.todos, 'status')
    },
    isEmpty () {
      return this.todos === null || Object.keys(this.todos).length === 0 || _.isEmpty(this.todos)
    },
    pageTitle () {
      document.title = this.$t('menu.user.my_tasks')
      return document.title
    }
  },
  mounted () {
    this.loading = true
    this.loadMyTodos()
      .then(resp => {
        this.todos = _.keyBy(resp.data, 'id')
      })
      .finally(() => { this.loading = false })
  },
  methods: {
    ...mapActions([
      'loadMyTodos'
    ]),
    getStatusLabel (status) {
      let labels = ['draft', 'open', 'completed', 'archived']
      return this.$t(labels[status])
    }
  }
}
</script>
